module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('h2', {
    staticClass: "L1f"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_chapter_001"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter One")]), _vm._v(" They can because they think they can")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_chapter_002"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Two")]), _vm._v(" Strawberries and cream and fruit-cake for tea")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_chapter_003"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Three")]), _vm._v(" A queer war")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Four")]), _vm._v(" Number 19 Squadron! Prepare to attack!")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Five")]), _vm._v(" His Spitfire literally blew up in his face …")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chapter_006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Six")]), _vm._v(" Vectored hither and thither…")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chapter_007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Seven")]), _vm._v(" The System")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chapter_008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Eight")]), _vm._v(" No time to be squeamish, lad!")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_chapter_009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Nine")]), _vm._v(" Piss off and get me an ambulance!")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_chapter_010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Ten")]), _vm._v(" Big Wing: Target London")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_chapter_011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Eleven")]), _vm._v(" We never ever considered being beaten …")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_chapter_012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Twelve ")]), _vm._v(" … the finest squadron commander…")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_chapter_013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Chapter Thirteen ")]), _vm._v(" Missing")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Postscript",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Postscript")]), _vm._v(" The Ultimate Band of Brothers?")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Appendix_001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Appendix I")]), _vm._v(" Squadron Leader 37859 Brian John Edward Lane DFC")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1",
    attrs: {
      "id": "pagevi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Appendix_002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Appendix II")]), _vm._v(" Aircraft and pilot losses suffered by 19 Squadron, 03.09.1939 – 20.06.1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Appendix_003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("Appendix III")]), _vm._v(" Combat Claims by 19 Squadron, 03.09.1939 – 20.06.1941")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1bt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Other_Books",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Dilip Sarkar (in order of publication)")])]), _vm._v(" "), _c('h2', {
    staticClass: "L1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0